export const OPEN_ESIGNATURE_TRANSACTION = 'ESignature.OPEN_ESIGNATURE_TRANSACTION';
export const RESOLVE_ESIGNATURE_TRANSACTION = 'ESignature.RESOLVE_ESIGNATURE_TRANSACTION';
export const SET_ESIGNATURE_DATA_ACTION = 'ESignature.SET_ESIGNATURE_DATA_ACTION';
export const ON_TEMPLATE_DATA_CHANGE_ACTION = 'ESignature.ON_TEMPLATE_DATA_CHANGE_ACTION';
export const ON_SELECTED_TEMPLATE_CHANGE_ACTION = 'ESignature.ON_SELECTED_TEMPLATE_CHANGE_ACTION';
export const ON_CLICK_SEND_TEMPLATE_ACTION = 'ESignature.ON_CLICK_SEND_TEMPLATE_ACTION';
